(function() {
  "use strict";

  angular.module("marketPlace.category").factory("GroupCategories", groupCategories);

  groupCategories.$inject = ["$resource", "API_URL"];

  function groupCategories($resource, API_URL) {
    const r = $resource(API_URL + "/api/group/categories/");

    // Remove extra actions
    delete r.prototype.$get;
    delete r.prototype.$save;
    delete r.prototype.$delete;
    delete r.prototype.$remove;

    return r;
  }
})();
